import { EMAIL_SUBSCRIPTION_REQUEST, EMAIL_SUBSCRIPTION_SUCCESS, EMAIL_SUBSCRIPTION_FAILURE } from '../types';

const initialState = {
  status: 'initial',
  error: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case EMAIL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        status: 'fetching',
      };
    case EMAIL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        status: 'success',
      };
    case EMAIL_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        status: 'failure',
      };
    default:
      return state;
  }
}
